// extracted by mini-css-extract-plugin
module.exports = {"container":"Search_container__12W9_","modal_container":"Search_modal_container__qiOyH"};